import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiUsers } from 'react-icons/fi';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { useGroups } from '../hooks/useGroups';
import '../styles/groups.scss';

export const Groups = () => {
    const { groups, isLoading, createGroup, isCreating } = useGroups();
    const navigate = useNavigate();

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [description, setDescription] = useState('');

    const openCreateModal = () => {
        setDescription('');
        setIsCreateModalOpen(true);
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        const created = await createGroup(description);
        if (created) setIsCreateModalOpen(false);
    };

    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
            </div>
        );
    }

    return (
        <section className="groups-page">
            <div className="page-header">
                <h1>المجموعات</h1>
                <button type="button" className="create-btn" onClick={openCreateModal}>
                    <FiPlus /> مجموعة جديدة
                </button>
            </div>

            {groups.length === 0 ? (
                <div className="empty-state">
                    <HiOutlineUserGroup className="icon" />
                    <p>لا توجد مجموعات حالياً</p>
                </div>
            ) : (
                <div className="groups-grid">
                    {groups.map((group) => (
                        <button
                            key={group._id}
                            type="button"
                            className="group-card"
                            onClick={() => navigate(`/groups/${group._id}`)}
                        >
                            <div className="group-card__icon"><HiOutlineUserGroup /></div>
                            <h3>المجموعة {group.number}</h3>
                            <p className="group-card__description">
                                {group.description || 'بدون وصف'}
                            </p>
                            <div className="group-card__count">
                                <FiUsers /> {group.memberCount} عضو
                            </div>
                        </button>
                    ))}
                </div>
            )}

            {isCreateModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>مجموعة جديدة</h2>
                        <p className="hint">سيتم ترقيم المجموعة تلقائياً</p>

                        <form onSubmit={handleCreate}>
                            <div className="input-group">
                                <label>الوصف (اختياري)</label>
                                <textarea
                                    rows={3}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="وصف مختصر للمجموعة..."
                                />
                            </div>

                            <div className="modal-actions">
                                <button type="submit" className="save-btn" disabled={isCreating}>
                                    {isCreating ? 'جارٍ الإنشاء...' : 'إنشاء'}
                                </button>
                                <button
                                    type="button"
                                    className="cancel-btn"
                                    onClick={() => setIsCreateModalOpen(false)}
                                    disabled={isCreating}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Groups;
